module.exports = __webpack_public_path__ + "static/InfraRed100-80ecdfd95fa07a18d27c84581103667f.svg";